// AgreementCheckbox.tsx
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

interface AgreementCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onOpenOffer: () => void;
  onOpenPrivacy: () => void;
  labels?: {
    prefix?: string;
    offer?: string;
    conjunction?: string;
    privacy?: string;
    suffix?: string;
  };
}

const linkSx = {
  cursor: 'pointer',
  color: 'primary.main',
  textDecoration: 'underline',
  '&:hover': { textDecoration: 'none' },
};

export const AgreementCheckbox = ({
  checked,
  onChange,
  onOpenOffer,
  onOpenPrivacy,
  labels = {},
}: AgreementCheckboxProps) => {
  const {
    prefix = 'З умовами',
    offer = 'Публічної оферти',
    conjunction = 'та',
    privacy = 'Політики конфіденційності',
    suffix = 'згоден',
  } = labels;

  return (
    <Box sx={{ mb: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {prefix}{' '}
            <Typography component="span" onClick={onOpenOffer} sx={linkSx}>
              {offer}
            </Typography>
            {' '}{conjunction}{' '}
            <Typography component="span" onClick={onOpenPrivacy} sx={linkSx}>
              {privacy}
            </Typography>
            {' '}{suffix}
          </Typography>
        }
      />
    </Box>
  );
};